import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Clock, ShieldCheck, Star } from 'lucide-react';
export const CHECKOUT_URL = 'https://colorpack.store/cart/45917604184262:1';
export const CTAButton = ({
  text,
  subtext = 'Acceso Inmediato • Pago Seguro',
  className = ''
}: {
  text: string;
  subtext?: string;
  className?: string;
}) => <a href={CHECKOUT_URL} className={`block w-full max-w-lg mx-auto transform transition-transform hover:scale-105 animate-pulse-scale ${className} no-underline`} data-id="element-188">
    <div className="bg-gradient-to-b from-green-400 to-green-600 rounded-xl p-1 shadow-[0_8px_0_rgb(21,128,61)] active:shadow-[0_0px_0_rgb(21,128,61)] active:translate-y-2 transition-all" data-id="element-189">
      <div className="bg-gradient-to-b from-green-500 to-green-600 rounded-lg py-4 px-4 sm:px-6 flex flex-col items-center justify-center text-white border border-green-400" data-id="element-190">
        <span className="font-montserrat font-black text-lg sm:text-xl md:text-2xl text-center uppercase tracking-wide flex items-center gap-2 text-shadow-sm" data-id="element-191">
          {text}{' '}
          <ArrowRight className="w-5 h-5 sm:w-6 sm:h-6 animate-bounce-x flex-shrink-0" data-id="element-192" />
        </span>
        {subtext && <span className="text-xs sm:text-sm font-inter font-medium opacity-90 mt-1 text-center" data-id="element-193">
            {subtext}
          </span>}
      </div>
    </div>
  </a>;
export const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="bg-red-50 border border-red-200 rounded-lg p-3 sm:p-4 flex flex-col items-center justify-center max-w-md mx-auto my-6 shadow-sm" data-id="element-194">
      <div className="flex items-center gap-2 text-red-600 mb-2" data-id="element-195">
        <Clock className="w-5 h-5" data-id="element-196" />
        <span className="font-inter font-bold text-sm sm:text-base uppercase tracking-wider" data-id="element-197">
          Oferta expira en:
        </span>
      </div>
      <div className="flex gap-3 text-2xl sm:text-3xl font-montserrat font-black text-red-600" data-id="element-198">
        <div className="bg-white px-3 py-1 rounded shadow-sm border border-red-100 min-w-[3rem] text-center" data-id="element-199">
          {minutes.toString().padStart(2, '0')}
        </div>
        <span data-id="element-200">:</span>
        <div className="bg-white px-3 py-1 rounded shadow-sm border border-red-100 min-w-[3rem] text-center" data-id="element-201">
          {seconds.toString().padStart(2, '0')}
        </div>
      </div>
    </div>;
};
const names = ['María G.', 'Carlos R.', 'Ana M.', 'Laura S.', 'José P.', 'Carmen T.', 'Diego L.', 'Sofía V.', 'Javier C.', 'Elena B.'];
const countries = ['México', 'Colombia', 'España', 'Perú', 'Argentina', 'Chile', 'Ecuador', 'Estados Unidos'];
export const SocialProofPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    country: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCountry = countries[Math.floor(Math.random() * countries.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1;
      setData({
        name: randomName,
        country: randomCountry,
        time: `hace ${randomTime} min`
      });
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 5000);
    };
    const initialDelay = setTimeout(showPopup, 3000);
    const interval = setInterval(showPopup, 15000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-202">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-24 sm:bottom-6 left-4 sm:left-6 z-50 bg-white rounded-lg shadow-xl border border-gray-200 p-3 flex items-center gap-3 max-w-[280px] sm:max-w-sm" data-id="element-203">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-204">
            <ShieldCheck className="w-6 h-6 text-green-600" data-id="element-205" />
          </div>
          <div data-id="element-206">
            <p className="text-sm font-inter text-gray-800" data-id="element-207">
              <span className="font-bold" data-id="element-208">{data.name}</span> de {data.country}
            </p>
            <p className="text-xs font-inter text-gray-500" data-id="element-209">
              Compró el Sistema NeuroAvance {data.time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};
export const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-210">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 p-3 sm:p-4 bg-white/95 backdrop-blur-sm border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-40 md:hidden" data-id="element-211">
          <a href={CHECKOUT_URL} className="block w-full no-underline" data-id="element-212">
            <div className="bg-gradient-to-b from-green-500 to-green-600 rounded-lg py-3 px-4 flex items-center justify-center text-white shadow-lg active:scale-95 transition-transform" data-id="element-213">
              <span className="font-montserrat font-bold text-lg uppercase tracking-wide" data-id="element-214">
                ACCEDER AHORA - $10.99
              </span>
            </div>
          </a>
        </motion.div>}
    </AnimatePresence>;
};
export const Section = ({
  children,
  className = '',
  dark = false
}: {
  children: React.ReactNode;
  className?: string;
  dark?: boolean;
}) => <section className={`py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8 ${dark ? 'bg-slate-900 text-white' : 'bg-white text-slate-900'} ${className}`} data-id="element-215">
    <div className="max-w-4xl mx-auto" data-id="element-216">{children}</div>
  </section>;